package com.essntl.features.task.domain.model

import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.domain.model.ProposalModel

data class TaskModel(
    val id: String,
    val createdAt: String,
    val updatedAt: String?,
    val updatedBy: String?,
    val notes: String?,
    val title: String?,
    val dueDate: String?,
    val itineraryService: ItineraryServiceModel?,
    val owner: ProfileModel?,
    val itinerary: ItineraryModel?,
    val proposal: ProposalModel?,
    val status: Status?,
) {
    enum class Status {
        Todo,
        Done,
        Blocked,
        Archive;

        override fun toString(): String {
            return when (this) {
                Todo -> "TO_DO"
                Done -> "DONE"
                Blocked -> "BLOCKED"
                Archive -> "ARCHIVE"
            }
        }
    }

    fun getChangedFields(other: TaskModel) =
        TaskModel(
            id = id,
            createdAt = createdAt,
            updatedAt = updatedAt,
            updatedBy = updatedBy,
            notes = if (notes.orEmpty() != other.notes.orEmpty()) other.notes else null,
            title = if (title.orEmpty() != other.title.orEmpty()) other.title else null,
            dueDate = if (dueDate.orEmpty() != other.dueDate.orEmpty()) other.dueDate else null,
            itineraryService = if (itineraryService != other.itineraryService) other.itineraryService else null,
            owner = if (owner != other.owner) other.owner else null,
            itinerary = if (itinerary != other.itinerary) other.itinerary else null,
            proposal = if (proposal != other.proposal) other.proposal else null,
            status = if (status != other.status) other.status else null,
        )

    val isEmpty get() = this.copy(id = "", createdAt = "", updatedAt = "", updatedBy = null) == empty

    companion object {
        val empty =
            TaskModel(
                id = "",
                createdAt = "",
                updatedAt = "",
                updatedBy = null,
                notes = null,
                title = null,
                dueDate = null,
                itineraryService = null,
                proposal = null,
                owner = null,
                itinerary = null,
                status = null,
            )
    }

    val isOwnerTask get() = itinerary == null && itineraryService == null
}